var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiggerLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5636 0.0127273L7.30422 0C5.84569 0 4.65234 1.14545 4.65234 2.54545V6.36364C4.65234 7.06364 5.24902 7.63636 5.97828 7.63636C6.70755 7.63636 7.30422 7.06364 7.30422 6.36364V5.09091H20.5636V22.9091H7.30422V21.6364C7.30422 20.9364 6.70755 20.3636 5.97828 20.3636C5.24902 20.3636 4.65234 20.9364 4.65234 21.6364V25.4545C4.65234 26.8545 5.84569 28 7.30422 28H20.5636C22.0221 28 23.2155 26.8545 23.2155 25.4545V2.54545C23.2155 1.14545 22.0221 0.0127273 20.5636 0.0127273Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2445 18.6915C5.70653 19.1196 6.49331 19.1183 6.99289 18.6886C7.49248 18.259 7.52321 17.5572 7.06118 17.1292L4.88543 15.1135L13.4351 15.0991C13.762 15.0986 14.0806 14.9822 14.3208 14.7756C14.561 14.5691 14.7031 14.2892 14.7159 13.9976C14.7286 13.706 14.611 13.4266 14.3889 13.2208C14.1667 13.015 13.8583 12.8997 13.5314 12.9003L4.98171 12.9146L7.33432 10.8913C7.83391 10.4617 7.86463 9.75993 7.4026 9.33189C6.94057 8.90385 6.15379 8.90517 5.65421 9.33483L1.1125 13.2408C0.612914 13.6705 0.582186 14.3722 1.04422 14.8003L5.2445 18.6915Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggerLogout);
export default __webpack_public_path__ + "static/media/bigger_logout.dda5c794b99507f202683b35ea69a8be.svg";
export { ForwardRef as ReactComponent };